<template>
  <div class="chart-bar" />
</template>

<script>
import chartInitMixin from '@/views/mixin/chartInitMixin'
import * as echarts from 'echarts'

export default {
  name: 'chart-bar-energy', // 实时能耗监测图
  props: {
    chartTitle: {
      type: String,
      required: false,
    },
    chartData: {
      type: Object,
      required: true,
    }
  },
  mixins: [ chartInitMixin, ],
  watch: {
    'chartData.series': {
      deep: true,
      handler() {
        this.update()
      }
    },
  },
  methods: {
    update() {
      const seriesData = this.chartData.series
      let xAxisData = this.chartData.labels
      //if (!xAxisData || !seriesData || !xAxisData.length || !seriesData.length) return
      if (!xAxisData || !seriesData) return
      let chartName = seriesData.map(item => item.name)
      const option = {
        color: '#3398DB',
        title: {
          show: false,
          text: this.chartTitle,
          textStyle: {
            fontFamily: '"OPPOSans R", "阿里巴巴普惠体 R", PingFangSC-Medium, PingFangSC, Arial, Helvetica, 黑体, sans-serif',
            fontSize: 15,
            fontWeight: '100',
            color: '#FFF1D9',
            textShadowBlur: 0,
          },
          left: 'left',
          top: '0',
        },
        tooltip: {
          show: true,
          trigger: 'axis',
          appendToBody: false,
          backgroundColor: 'rgba(255,255,255,0.3)',
          extraCssText: "border-radius: 0;background: rgba(0,0,0,0.8);padding: 15px;",
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: 'rgba(255,255,255,0.4)',
              width: 2
            },
          },
        },
        grid: {
          top: '32px', // 上边距为0
          left: '3%', // 左边距
          right: '3%', // 右边距
          bottom: 0, // 下边距为0
          containLabel: true // 确保标签不会被裁剪
        },
        legend: {
          top: 0,
          right: 10, // 增加图例与右侧的距离
          itemWidth: 8,
          itemHeight: 8,
          icon: 'circle',
          textStyle: {
            color: 'rgba(255,255,255,0.5)',
            fontFamily: '"OPPOSans R", "阿里巴巴普惠体 R", PingFangSC-Medium, PingFangSC, Arial, Helvetica, 黑体, sans-serif',
          },
          data: chartName,
        },
        xAxis: {
          type: 'category',
          data: xAxisData,
          axisTick: {
            show: false,
            alignWithLabel: true
          },
          axisLine: {
            show: true,
          },
          axisLabel: { // 坐标轴样式
            interval: 0, // 强制显示所有标签
            rotate: 0, // 如果标签过长，可以旋转显示
            fontSize: 10,
            color: 'rgba(255,255,255,0.45)', // 坐标轴标签颜色
          },
        },
        yAxis: [
          {
            type: 'value',
            position: 'left',
            axisLabel: {
              formatter: '{value}', // 格式化y轴标签
              fontSize: 10,
              color: 'rgba(255,255,255,0.45)', // 坐标轴标签颜色
            },
            splitLine: { // 网格线
              show: false,
              lineStyle: {
                color: 'rgba(255,255,255,0.15)',
                width: 1,
                type: 'dashed',
              }
            },
          },
          {
            type: 'value',
            position: 'right',
            axisLabel: {
              formatter: '{value}', // 格式化y轴标签
              fontSize: 10,
              color: 'rgba(255,255,255,0.45)', // 坐标轴标签颜色
            },
            splitLine: { // 网格线
              show: true,
              lineStyle: {
                color: 'rgba(255,255,255,0.15)',
                width: 1,
                type: 'dashed',
              }
            },
          },
        ],
        series: [
          { // 能耗
            name: chartName[0],
            type: 'bar',
            barWidth: '15px',
            yAxisIndex: 0,
            color: '#00b6e7',
            itemStyle: {
              // barBorderRadius: [5, 5, 0, 0],
              color: function (params) {
                const colors = ['#00cad2', '#00b6e7', '#00a6fe']
                return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: colors[0]},
                  {offset: 0.5, color: colors[1]},
                  {offset: 1, color: colors[2]},
                ])
              },
            },
            z: 0,
            zlevel: 1,
            data: seriesData[0].data
          },
          { // bar分割成块状
            type: 'pictorialBar',
            yAxisIndex: 0,
            barWidth: '15px',
            color: '#02171f',               // 符号设置为背景色
            tooltip: {
              show: false
            },
            symbolRepeat: true,             // 符号是否重复
            symbolMargin: 3,                // 符号间距
            symbol: 'rect',                 // 符号形状为矩形
            symbolClip: true,               // 是否对超出范围的图形进行裁剪
            symbolSize: [17, 2],            // 符号大小
            symbolPosition: 'start',        // 符号位置在开始
            symbolOffset: [-10, 0],         // 符号偏移量
            z: 10,
            zlevel: 3,
            data: seriesData[0].data
          },
          { // PUE
            name: chartName[1],
            type: 'bar',
            barWidth: '15px',
            yAxisIndex: 1,
            color: '#f89c4d',
            markLine: {
              lineStyle: {
                type: 'dashed',
                color: 'darkred',
                width: 2,
              },
              data: [
                {
                  name: 'PUE要求',
                  yAxis: 1.20,
                }
              ]
            },
            itemStyle: {
              // barBorderRadius: [5, 5, 0, 0],
              color: function (params) {
                const colors = ['#f8c140', '#f89c4d', '#fd4f64']
                return new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {offset: 0, color: colors[0]},
                  {offset: 0.5, color: colors[1]},
                  {offset: 1, color: colors[2]},
                ])
              },
            },
            z: 0,
            zlevel: 1,
            data: seriesData[1].data
          },
          { // bar分割成块状
            type: 'pictorialBar',
            yAxisIndex: 1,
            barWidth: '15px',
            color: '#02171f',               // 符号设置为背景色
            tooltip: {
              show: false
            },
            symbolRepeat: true,             // 符号是否重复
            symbolMargin: 3,                // 符号间距
            symbol: 'rect',                 // 符号形状为矩形
            symbolClip: true,               // 是否对超出范围的图形进行裁剪
            symbolSize: [17, 2],            // 符号大小
            symbolPosition: 'start',        // 符号位置在开始
            symbolOffset: [10, 0],          // 符号偏移量
            z: 10,
            zlevel: 3,
            data: seriesData[1].data
          },
        ]
      }
      this.chart.setOption(option)
      // console.log('#option#', option)
    }
  }
}
</script>
